export default __webpack_public_path__ + "static/media/onCall.7ea52262.svg";